// extracted by mini-css-extract-plugin
export default {"richTextContainer":"RichText_richTextContainer__9YlDj","richTextHeader":"RichText_richTextHeader__gXf7K"};